import React from 'react'
import Ink from 'react-ink';
import { setGroup } from '../actions/layoutActions.js';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as general from '../constants/General'

class MenuButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    this.props.setGroup(this.props.id);
  }

  render() {
    const {
      text,
      fileAttachmentId,
      shouldBlink
    } = this.props;

    let style = {};
    let labelClass = 'menubutton-label';
    let menuButtonClass = 'menubutton';

    if (fileAttachmentId > 0) {
      style.backgroundImage = `url('${general.API_URL_BUTTON_IMAGE}/${fileAttachmentId}')`;

      labelClass += ' with-image';
    }

    if(shouldBlink){
      menuButtonClass += ' blinkMenuButton';  
    }
    
    return (
        <button className={menuButtonClass} style={style} onClick={this.handleTouchTap}>
          <div className={labelClass}>{text}</div>
          <Ink />
        </button>)
  }
}

MenuButton.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  setGroup: PropTypes.func.isRequired
}

function mapStateToProps() {
  return {
  }
}

export default connect(mapStateToProps, { setGroup })(MenuButton)



// WEBPACK FOOTER //
// src/components/MenuButton.jsx